import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import type { ConsumptionEvent } from '../consumption/ConsumptionEvents.ts';

export const useSendAnalyticsEvents = (): {
	sendEvent: (event: ConsumptionEvent, skipVisibilityCheck?: boolean) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendEvent = useCallback(
		(event: ConsumptionEvent, skipVisibilityCheck: boolean = false): void => {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			if (document.visibilityState === 'hidden' && !skipVisibilityCheck) {
				// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
				document.addEventListener(
					'visibilitychange',
					() => {
						// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
						if (document.visibilityState === 'visible') {
							createAnalyticsEvent(event).fire();
						}
					},
					{ once: true },
				);
			} else {
				createAnalyticsEvent(event).fire();
			}
		},
		[createAnalyticsEvent],
	);

	return { sendEvent };
};
